module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/News-226ce0307b4f3a35e4f75b87a400abc8.png";